import { render } from "./HeroFish.vue?vue&type=template&id=718b869d"
import script from "./HeroFish.vue?vue&type=script&lang=js"
export * from "./HeroFish.vue?vue&type=script&lang=js"

import exportComponent from "/Users/dario/Projects/rayfish/public-www/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__